import { render, staticRenderFns } from "./ProdutoImagem.vue?vue&type=template&id=10d730c2&scoped=true"
import script from "./ProdutoImagem.vue?vue&type=script&lang=js"
export * from "./ProdutoImagem.vue?vue&type=script&lang=js"
import style0 from "./ProdutoImagem.vue?vue&type=style&index=0&id=10d730c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d730c2",
  null
  
)

export default component.exports